import { z } from 'zod'

export const SRT_MODE_ENUM = {
  CALLER: 'caller',
  // LISTENER: 'listener', // Not supported yet
} as const

export const srtModeSchema = z.nativeEnum(SRT_MODE_ENUM)
export type SrtMode = typeof srtModeSchema['_type']

export const srtUrlSchema = z
  .string()
  .regex(
    /^srt:\/\/([a-zA-Z0-9-_.]+):(\d+)(\/\S*)?(\?\S*)?$/,
    "URL must start with 'srt://'"
  )
  .transform((v) => v ?? 'srt://')

export const srtDestinationStreamIdSchema = z
  .string()
  .nullable()
  .transform((v) => v ?? null)

export const srtDestinationPassphraseSchema = z
  .string()
  .nullable()
  .transform((v) => v ?? null)

export const srtFormSchema = z.object({
  mode: srtModeSchema.default(SRT_MODE_ENUM.CALLER),
  passphrase: srtDestinationPassphraseSchema.default(null),
  streamId: srtDestinationStreamIdSchema.default(null),
  latency: z
    .number()
    .min(1)
    .max(10000)
    .default(1000)
    .transform((v) => v ?? 1000),
  url: srtUrlSchema.default('srt://'),
})
export type SrtForm = z.infer<typeof srtFormSchema>
